import { useEffect, useRef } from 'react';
import './crest-background.css';

/** Pure decoration: no state, form events, navigation or authentication access. */
export function CrestBackground() {
  const canvas = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    let cancelled = false;
    let dispose: (() => void) | undefined;
    // Loading and mask preparation never gate the login render.
    void import('./crest-renderer.js')
      .then(async ({ startCrestBackground }) => {
        if (cancelled || !canvas.current) return;
        const stop = await startCrestBackground(canvas.current);
        if (cancelled) stop();
        else dispose = stop;
      })
      .catch(() => { /* A failed decoration leaves the existing white login intact. */ });
    return () => { cancelled = true; dispose?.(); };
  }, []);
  return <canvas ref={canvas} className="sh-crest-background" aria-hidden="true" />;
}
